import { Component, ElementRef, Input, OnInit, ViewChild,OnDestroy} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { GroupService } from '@ascschool/services/user/group.service';
import { Group } from '@ascschool/model/user/group.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Observable,Subject } from 'rxjs';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { GroupSchoolService } from '@ascschool/services/user/group-schools.service';
import { map, takeUntil} from 'rxjs/operators';
import { ButtonType } from '@ascschool/interface/setting';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { ChangeDetectorRef } from '@angular/core';
import { Level } from '@ascschool/model/category/level.model';
import { SystemUser } from '@ascschool/model/user/system-user.model';
import { UserSchoolService } from '@ascschool/services/user/user-schools.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { StaffTypeOfDisabilityService } from '@ascschool/services/user/staff-typeofdisability.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { StaffStudentService } from '@ascschool/services/user/staff-student.service';

@Component({
  selector: 'app-them-nkt',
  templateUrl: './them-nkt.component.html',
  styleUrls: ['./them-nkt.component.scss']
})
export class ThemNguoiKhuyetTatComponent implements OnInit,OnDestroy {
  @Input() dataTransmission: any;
  $unSubscribe =new Subject();
  systemUser = new SystemUser();
  searchAdvanced: boolean = false;
  loading: boolean = false;
  firstRowOnPage: number = 0;
  total: number = 0;
  pageSizeOptions: number[] = [50, 100, 200];
  pageIndex: number = 1;
  pageSize = this.pageSizeOptions[2];
  listGroupSelected: number[] = [];
  searchForm: FormGroup;
  studentList: any;
  checkedAll: boolean = false;
  commonFilter = new CommonFilter();

  getTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  typeOfDisabilitysSubscription: any;
  typeOfDisabilitysControl = new FormControl();
  getLevelsACFn: (value: any) => Observable<any>;
  levelsSubscription: any;
  levelsControl = new FormControl();


  isEditMode = false;
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  searchTerm: string = '';
  categoryModel = new CategoryModel();
  Total: number = 0;
  width: number;
  numberControl: number;
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  private elementPageHeaderTable: ElementRef;

  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private modalService: NzModalService,
    public sizePageService: SizePageService,
    public utilsService: UtilsService,
    private staffTypeOfDisabilityService: StaffTypeOfDisabilityService,
    private typeOfDisabilitysService: TypeOfDisabilityService,
    private levelsService: LevelService,
    private service: StaffStudentService,
    private fb: FormBuilder,
  ) {
    
  
  }

  ngOnInit() { 
    if(this.dataTransmission){ 
      this.commonFilter.TypeOfDisabilityId = this.dataTransmission.typeOfDisabilityId;
    }
    const curentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.studentList = [];
    this.staffTypeOfDisabilityService.getStaffTypeOfDisabilityById(this.dataTransmission.id).subscribe((res: any) => {
      this.commonFilter.StaffId = res.staffId
      this.commonFilter.StaffTypeOfDisabilityId = this.dataTransmission.id;
      if (this.commonFilter.StaffId) {
        this.loadList();
        (delete (this.commonFilter.TypeOfDisabilityId))
      }
    });
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[2];
    this.commonFilter.IsApproved = true;
    this.loadTypeOfDisabilitys();
    this.loadLevels();
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadTypeOfDisabilitys() {
    this.getTypeOfDisabilitysACFn = (value: any) => this.typeOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.typeOfDisabilitysSubscription) this.typeOfDisabilitysSubscription = this.typeOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.typeOfDisabilitysControl.value);
    });
  }
  changeTypeOfDisabilitys(control: FormControl) {
    this.typeOfDisabilitysControl = control;
  }
  loadLevels() {
    this.getLevelsACFn = (value: any) => this.levelsService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.levelsSubscription) this.levelsSubscription = this.levelsControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'LevelId', this.levelsControl.value);
    });
  }
  changeLevels(control: FormControl) {
    this.levelsControl = control;
  }
  search() {
  
    this.commonFilter.PageIndex = 1;
    this.loadList();
  }

  loadList() {
    this.loading = true;
    this.studentList = [];

    this.service.getStaffStudent(this.commonFilter).pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => { 
        if(response.results.length <= 0){
           this.search();
        }
        const list = response.results ? response.results : [];
        this.Total = (response && response.rowCount) ? response.rowCount : 0;
        this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
        this.studentList = (list) ? list : [];
        this.loading = false;
      },
      (err: any) => {
        this.studentList = [];
        this.loading = false;
      }
    );
  }

  Update() {
    this.setOfCheckedId.forEach(item => {
      this.listGroupSelected.push(item); 
    });
    if(this.listGroupSelected.length > 0){
      if(this.dataTransmission.id && this.dataTransmission.id != null){
        this.service.addMultiple({staffTypeOfDisabilityId: this.dataTransmission.id, listStudentId: this.listGroupSelected}).subscribe((res)=>{
          if(res.statusCode == 0){
            this.utilsService.notifyResponse(res);
            this.close();
          }
          else{
            this.utilsService.notifyResponse(res);
          }
        })
      }
    }else{
      this.msg.warning('Vui lòng chọn học sinh!');
    }
  }
  //#region "Dành cho Component cha"
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.loadList();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.loadList();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard 
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }


  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  //#endregion "My Region"
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}

}
